import React from 'react';
import './main.less';

import { Link } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import values from 'lodash/values';

import { namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import SelectField from '../../../shared/form-elements/select/field';
import InputField from '../../../shared/form-elements/input';
import UploadImage from '../../../shared/form-elements/new-upload/upload-image';
import { isRequired, isSelected } from '../../../shared/form/validation';

function ImageEditor({ intl, languages, ...props }) {
	const imageId = props.params.id;
	return (
		<div className='form-container'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit popup image')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form onSubmit={props.handleSubmit}>
					<div className='banners-fields-horizontally'>
						<div className='banners-image-editor-inputs'>
							<Field
								className='banners-image-editor-field'
								name='title'
								component={InputField}
								validate={[isRequired]}
								placeholder={intl('Image title')}
							/>
							<div className='banners-info-field'>
								<Field
									name='language'
									component={SelectField}
									langs={languages}
									searchable={false}
									validate={[isSelected]}
									options={values(languages).map(({ id }) => ({
										label: id,
										value: id
									}))}
									placeholder={intl('Image language')}
								/>
							</div>
						</div>
						<Field
							name='image'
							title={intl('image')}
							format={null}
							disabled={!!imageId}
							validate={[isRequired]}
							component={UploadImage}
						/>
					</div>
					<div className='banners-buttons'>
						<button className='ui-btn ui-btn-primary'>
							{intl('Save')}
						</button>
						<Link
							className='ui-btn ui-btn-cancel'
							to='/popups/images'
						>
							{intl('Cancel')}
						</Link>
					</div>
				</form>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		// -----------------------------------------
		languages: selectors.getLanguages(state)
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(ImageEditor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/popups/image/editor/main.js